/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pg_LoginInputs */



/**
* | output |
* | --- |
* | "## Logging In If you already have an account, use the **Login** tab. Enter your email and password, or use one of the alternative sign-in methods:" |
*
* @param {Pg_LoginInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const pg_login = /** @type {((inputs?: Pg_LoginInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pg_LoginInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("## Se connecter\n\nSi vous avez déjà un compte, utilisez l'onglet **Connexion**. Entrez votre email et votre mot de passe, ou utilisez l'une des méthodes de connexion alternatives :")
	if (locale === "es") return /** @type {LocalizedString} */ ("## Inicio de sesión\n\nSi ya tiene una cuenta, use la pestaña **Iniciar sesión**. Ingrese su correo electrónico y contraseña, o use uno de los métodos alternativos de inicio de sesión:")
	if (locale === "pt") return /** @type {LocalizedString} */ ("## Fazendo Login\n\nSe você já tem uma conta, use a aba **Entrar**. Insira seu e-mail e senha, ou use um dos métodos alternativos de acesso:")
	if (locale === "it") return /** @type {LocalizedString} */ ("## Accedere\n\nSe hai già un account, usa la scheda **Login**. Inserisci email e password, oppure usa uno dei metodi di accesso alternativi:")
	return /** @type {LocalizedString} */ ("## Logging In\n\nIf you already have an account, use the **Login** tab. Enter your email and password, or use one of the alternative sign-in methods:")
});